import { toast } from 'react-toastify';

const useToast = () => {
  const showSuccess = (message) => {
    if (!message || (typeof message === 'string' && !message.trim())) return;
    toast.success(message);
  };
  const showError = (message) => {
    if (!message || (typeof message === 'string' && !message.trim())) return;
    toast.error(message);
  };
  const showWarning = (message) => {
    if (!message || (typeof message === 'string' && !message.trim())) return;
    toast.warning(message);
  };

  return {
    toasts: [], // Kept for backwards compatibility if some components still map over it
    removeToast: () => {},
    showSuccess,
    showError,
    showWarning
  };
};

export default useToast;
